"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ApexChartComponent = _interopRequireDefault(require("./ApexChartComponent"));
var _tickersActions = require("../../redux/actions/tickersActions");
var _config = _interopRequireDefault(require("../../config"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var locale = _config["default"].global.locale;
var mapStateToProps = function mapStateToProps(state) {
  var tickers = state.tickers,
    apexCore = state.apexCore;
  var level1 = apexCore.level1,
    level2 = apexCore.level2;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var selectedInstrumentId = selectedInstrument.InstrumentId;
  var marketPrice = selectedInstrumentId && level1[selectedInstrument.InstrumentId] ? level1[selectedInstrument.InstrumentId].LastTradedPx : 0;
  return {
    precision: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement),
    locale: locale,
    chartData: {
      level2: level2,
      tickers: tickers,
      marketPrice: marketPrice
    }
  };
};
var mapDispatchToProps = {
  changeTickersInterval: _tickersActions.changeTickersInterval
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ApexChartComponent["default"]);